module.exports = __webpack_public_path__ + "img/step2-c.a60187e0.png";